import { useLanguage } from "@/context/LanguageContext";
import { VIDEOS } from "@/data/content";
import SectionHeader from "./SectionHeader";
import Reveal from "./Reveal";

export default function Videos() {
  const { t } = useLanguage();
  const v = t.videos;

  return (
    <section id="videos" className="border-y border-white/5 bg-[#0A0D14]" data-testid="videos-section">
      <div className="mx-auto max-w-7xl scroll-mt-20 px-4 py-20 sm:px-6 sm:py-28 lg:px-8">
        <SectionHeader number={`${v.number} · ${t.nav.videos}`} title={v.title} />

        <div className="grid gap-8 lg:grid-cols-1">
          {VIDEOS.map((video, i) => (
            <Reveal key={video.embedUrl} delay={0.08 * i}>
              <article className="overflow-hidden rounded-2xl border border-white/10 bg-[#0E131F]" data-testid={`video-card-${i}`}>
                <div className="relative aspect-video w-full bg-black">
                  <iframe
                    src={video.embedUrl}
                    title={video.title}
                    className="absolute inset-0 h-full w-full"
                    frameBorder="0"
                    allow="autoplay; fullscreen; picture-in-picture"
                    allowFullScreen
                    loading="lazy"
                    data-testid={`video-iframe-${i}`}
                  />
                </div>
                <div className="p-5 sm:p-6">
                  <p className="font-mono text-[10px] font-semibold uppercase tracking-[0.2em] text-sky-400">
                    {v.featured} · {video.duration}
                  </p>
                  <h3 className="mt-1.5 font-display text-lg font-bold uppercase tracking-wide text-white">
                    {video.title}
                  </h3>
                </div>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2}>
          <p className="mt-6 text-xs text-slate-500">
            {v.note} {v.more}
          </p>
        </Reveal>
      </div>
    </section>
  );
}
